import React from "react";
import { useHistory } from "react-router-dom";
import "./Contact2.css";

const tags = [
  // Première ligne
  { label: "Maçonnerie", icon: "🧱", primary: true },
  { label: "Toiture", icon: "🏠", primary: false },
  { label: "Construction", icon: "🏛️", primary: true },
  { label: "Placo", icon: "🧰", primary: true },
  { label: "Électricité", icon: "⚡", primary: false },
  // Deuxième ligne
  { label: "Plomberie", icon: "🔧", primary: true },
  { label: "Revêtement de sol", icon: "🏗️", primary: false },
  { label: "Ravalement de façade", icon: "🎨", primary: true },
  { label: "Rénovation clé en main", icon: "🔨", primary: false },
  { label: "Extension", icon: "📐", primary: true },
  { label: "Salle de bain clé en main", icon: "🛁", primary: false },
  { label: "Peinture", icon: "🖌️", primary: true },
];

const ServiceTagsSection = () => {
  const history = useHistory();

  return (
    <section className="service-tags-wrapper">
      <div className="service-tags-inner">
        <header className="service-header">
          <h2 className="main-title">
            Un partenaire unique pour tous vos projets d'aménagement intérieur
          </h2>
          <p className="sub-title">
            Vous avez une idée en tête ? Notre équipe est à votre écoute pour
            concrétiser toutes vos envies.
          </p>
        </header>

        <ul className="tags-container">
          {tags.map((tag, index) => (
            <li
              key={index}
              className={`tag ${tag.primary ? "tag-primary" : "tag-secondary"}`}
              onClick={() => {
                history.push(`/service/${encodeURIComponent(tag.label)}`);
              }}
              style={{ cursor: 'pointer' }}
            >
              <span className="tag-icon">{tag.icon}</span>
              <span className="tag-label">{tag.label}</span>
            </li>
          ))}
        </ul>


      </div>
    </section>
  );
};

export default ServiceTagsSection;
